import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import { AppBarCMS } from '../../../../basic';
import DepartmentForm from './DepartmentForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';

import {
  useSaveDepartmentMutation,
  useGetDepartmentQuery,
  useGetDepartmentsQuery,
} from '../../../../../redux/services/departments';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form as AntdForm } from 'antd';
import Form from '../../../../antd/form/Form/Form';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const DepartmentsEdit = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Úprava pracoviska FRI') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess } = useToastMessages();

  const { data: department, isLoading: departmentLoading } =
    useGetDepartmentQuery(id);

  const [saveDepartment, { isSuccess: isSaveSuccess }] =
    useSaveDepartmentMutation();

  const { refetch } = useGetDepartmentsQuery();

  const [form] = AntdForm.useForm();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsDepartments);
      refetch();
    }
  }, [isSaveSuccess]);

  const initials = {
    description_sk: undefined,
    description_en: undefined,
    activities_sk: undefined,
    activities_en: undefined,
    ...department,
  };

  return departmentLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Úprava pracoviska')}
        backUrl={routes.cmsDepartments}
        backUrlTooltip={t('Pracoviská')}
        permissionsBasic="departments"
      />
      <div style={{ margin: '10px' }}>
        <Form
          form={form}
          initialValues={initials}
          onFinish={(values) => {
            saveDepartment({ body: values, id: department.id });
          }}
        >
          <DepartmentForm form={form} />
        </Form>
      </div>
    </>
  );
};

export default DepartmentsEdit;
